module.exports = __webpack_public_path__ + "img/step3-dark.b47308cf.png";